import { render, staticRenderFns } from "./LegPickerForm.vue?vue&type=template&id=2bf20bb2"
import script from "./LegPickerForm.vue?vue&type=script&setup=true&lang=ts"
export * from "./LegPickerForm.vue?vue&type=script&setup=true&lang=ts"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports